import { EventStatusId } from '../EventStatusId.js'
import { ResultId } from '../ResultId.js'
import { VolleyballEventStatusId } from './EventStatusId.js'
import { VolleyballResultId } from './VolleyballResultId.js'

export const volleyballStatusResultsMap: {
  [key in EventStatusId]?: ResultId[]
} = {
  [VolleyballEventStatusId.FirstSet]: [VolleyballResultId.FirstSet],
  [VolleyballEventStatusId.SecondSet]: [VolleyballResultId.SecondSet],
  [VolleyballEventStatusId.ThirdSet]: [VolleyballResultId.ThirdSet],
  [VolleyballEventStatusId.FourthSet]: [VolleyballResultId.FourthSet],
  [VolleyballEventStatusId.FifthSet]: [VolleyballResultId.FifthSet],
  [VolleyballEventStatusId.GoldenSet]: [VolleyballResultId.GoldenSet],
}
